import Leaflet from 'leaflet';
import { buildPopup } from './popup';
import { DEFAULT_ZOOM_ON_CLICK_LEVEL, MARKER_CLICK_FOCUS } from '../constants';
import { getTargetLocation, getTargetLocationFocusedOnPopup } from './traversal';

/**
 * Build a marker will all passed options
 * If required bind a popup and/or a context to it.
 * @param marker
 * @param markerOptions
 * @param leafletMap
 * @returns Leaflet.Marker
 */
export var buildMarker = function buildMarker(marker, markerOptions, leafletMap) {
  if (marker.geoLocation.latitude && marker.geoLocation.longitude) {
    var coordinates = Leaflet.latLng(marker.geoLocation.latitude, marker.geoLocation.longitude);
    var markerBody = marker.body ? marker.body : '<div class="marker"/>';
    var options = {
      icon: Leaflet.divIcon({
        className: 'map-marker',
        html: markerBody
      }),
      id: marker.id
    };
    var markerToRender = Leaflet.marker(coordinates, options);
    if (markerOptions.showPopup) {
      var popup = buildPopup(marker, markerOptions.popupContentConstructor);
      markerToRender.bindPopup(popup);
    }
    markerToRender.on('popupclose', function () {
      markerToRender.setIcon(Leaflet.divIcon({
        className: 'map-marker',
        html: markerBody
      }));
    });
    markerToRender.on('popupopen', function () {
      markerToRender.setIcon(Leaflet.divIcon({
        className: 'map-marker map-marker--active',
        html: markerBody
      }));
    });
    markerToRender.on('click', function (event) {
      if (markerOptions.contextSetter) {
        markerOptions.contextSetter(marker);
      }
      if (markerOptions.onClick) {
        markerOptions.onClick(markerToRender, leafletMap, markerOptions);
      }
    });
    return markerToRender;
  }
  return null;
};

/**
 * This is the default marker click behaviour that can be overridden
 * The marker click focus on popup is optimized for a default popup which stands above a marker
 * For intricate popups it is recommended to overwrite this method
 * By default we do not zoom in on click, this requires a custom implementation
 * @param marker
 * @param leafletMap
 * @param markerOptions
 */
export var markerClickBehaviour = function markerClickBehaviour(marker, leafletMap, markerOptions) {
  if (markerOptions.moveToMarkerOnClick) {
    var targetZoom = markerOptions.zoomLevelOnClick || DEFAULT_ZOOM_ON_CLICK_LEVEL;
    var maxZoom = leafletMap.getMaxZoom();
    var currentZoom = leafletMap.getZoom();
    var zoom = currentZoom;
    if (markerOptions.zoomOnClick) {
      zoom = maxZoom < targetZoom ? maxZoom : targetZoom;
    }
    var zoomScale = markerOptions.zoomOnClick ? leafletMap.getZoomScale(currentZoom, zoom) : 1;
    var location = marker.getLatLng();
    if (markerOptions.markerClickFocus === MARKER_CLICK_FOCUS.POPUP) {
      var _marker$getPopup;
      var popupHeight = ((_marker$getPopup = marker.getPopup()) === null || _marker$getPopup === void 0 || (_marker$getPopup = _marker$getPopup.getElement()) === null || _marker$getPopup === void 0 ? void 0 : _marker$getPopup.getBoundingClientRect().height) || 0;
      location = getTargetLocationFocusedOnPopup(location, leafletMap, popupHeight, zoomScale, markerOptions.focusPadding);
    } else {
      location = getTargetLocation(location, leafletMap, zoomScale, markerOptions.focusPadding);
    }
    leafletMap.setView(location, zoom);
  }
};
export default {
  buildMarker: buildMarker,
  markerClickBehaviour: markerClickBehaviour
};